import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';

import { getNameInCurrentLanguage } from 'helpers/intl';

import { STATUS_NEW, STATUS_IN_PROGRESS, STATUS_CLARIFY, STATUS_COMPLETED } from 'js/constants';

class OrderServiceCarRegistrationData extends React.Component {
  renderStatus = () => {
    const { intl, service } = this.props;
    const messages = intl.messages;

    switch (service.getStatus()) {
      case STATUS_NEW:
        return messages.new;

      case STATUS_IN_PROGRESS:
        return messages.in_progress;

      case STATUS_CLARIFY:
        return messages.clarify;

      case STATUS_COMPLETED:
        return messages.finished;
    }
  };

  renderDocsList = () => {
    const { intl, appIntl, entity } = this.props;
    const messages = intl.messages;

    let res = [];
    for (let i = 0; i < entity.getCarRegistrationData().getRequiredDocuments().length; i++) {
      const requiredDocument = entity.getCarRegistrationData().getRequiredDocuments()[i];
      res.push(
        <div key={i}>
          <i
            class={
              requiredDocument.getIsSent() ? 'fal fa-check-circle text-success' : 'fal fa-times-circle text-warning'
            }
          />{' '}
          {getNameInCurrentLanguage(requiredDocument.getType().getName(), appIntl)} (
          {requiredDocument.getOriginalNeeded() ? messages.in_original : messages.a_copy})
        </div>
      );
    }

    return res;
  };

  render() {
    const { intl, service, entity } = this.props;
    const messages = intl.messages;

    return (
      <div>
        <dl class="no-margin">
          <dt>{messages.name}</dt>
          <dd>{messages.car_registration}</dd>

          <dt class="m-t-5">{messages.price}</dt>
          <dd>
            <FormattedNumber value={service.getPrice()} style="currency" currency={entity.getCurrency()} />
          </dd>

          <dt class="m-t-5">{messages.status}</dt>
          <dd>{this.renderStatus()}</dd>

          {service.getStatus() === STATUS_IN_PROGRESS ? (
            <React.Fragment>
              <dt class="m-t-5">{messages.documents}</dt>
              <dd>{this.renderDocsList()}</dd>
            </React.Fragment>
          ) : null}

          {service.getStatus() === STATUS_CLARIFY ? (
            <React.Fragment>
              <dt class="m-t-5">{messages.notification}</dt>
              <dd>
                <i class="far fa-info-circle" /> {service.getClarifyText()}
              </dd>
            </React.Fragment>
          ) : null}

          {entity.getCarRegistrationData().getRequestedCustomLicensePlateNumber() ? (
            <React.Fragment>
              <dt class="m-t-5">{messages.with_custom_license_plate_number}</dt>

              {entity.getCarRegistrationData().getCustomLicensePlateNumber() &&
              entity.getCarRegistrationData().getCustomLicensePlateNumberReservationNumber() ? (
                <React.Fragment>
                  <dd />
                  <dt class="m-t-5">{messages.license_plate_number}</dt>
                  <dd>{entity.getCarRegistrationData().getCustomLicensePlateNumber()}</dd>

                  <dt class="m-t-5">{messages.license_plate_reservation_number}</dt>
                  <dd>{entity.getCarRegistrationData().getCustomLicensePlateNumberReservationNumber()}</dd>
                </React.Fragment>
              ) : (
                <dd>{messages.license_plate_reservation_data_missing}</dd>
              )}
            </React.Fragment>
          ) : null}
        </dl>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(OrderServiceCarRegistrationData));
